import Dialog from "@ergeon/core-components/exports/Dialog.ts";
import PopUp from "@ergeon/core-components/exports/PopUp.ts";
import { ExclamationTriangleIcon } from '@ergeon/icons/hero/solid';
import { AdjustmentsHorizontalIcon } from '@ergeon/icons/hero/mini';

/**
 * Location-specific twin of ResetPermissionsModal. Location can be blocked on
 * TWO levels — the browser's site permission AND the operating system's
 * Location Services (the site toggle then looks enabled while the API still
 * reports denied) — so the steps cover both.
 */
export default function ResetLocationModal({ onClose }: { onClose(): void }) {
  return (
    <PopUp isVisible maxWidth="small" onChangeVisible={onClose}>
      <Dialog
        hideCancelButton
        icon={<ExclamationTriangleIcon className="size-6 text-orange-500 dark:text-orange-400" />}
        isVisible
        onDismiss={onClose}
        onSubmit={onClose}
        submitButtonFlavor="primary"
        submitButtonText="Ok"
        title="Allow location to continue">
        <ol className="list-inside list-decimal">
          <li className="mb-2">
            Click the <AdjustmentsHorizontalIcon className="inline-block size-5 align-text-bottom" /> in your browser's address bar and allow Location
          </li>
          <li className="mb-2">
            If it is already allowed, enable Location Services for your browser in the
            device settings (on a Mac: System Settings → Privacy &amp; Security → Location Services)
          </li>
          <li className="mb-2">
            Refresh the page
          </li>
        </ol>
      </Dialog>
    </PopUp>
  );
}
